import styled from "styled-components";
import { PrimaryButton } from "../../Button";
import { themeColor, rtl } from "../../../shared/styles-utils";
import { FlexCol } from "../../../shared/globals";

export const RouteSection = styled(FlexCol)<{ isRecoveryCart?: boolean }>`
  width: 100%;
  flex-direction: column-reverse;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: ${({ isRecoveryCart }) =>
      isRecoveryCart ? "end" : "space-between"};
  }
`;

export const GoBackButton = styled.button`
  display: flex;
  background-color: inherit;
  align-items: center;
  justify-content: center;
  color: ${themeColor("primary")};
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;

  div {
    display: flex;
    transform: scaleX(${rtl("-1", "1")});
    padding-right: 8px;
  }
`;

export const ContinueButton = styled(PrimaryButton)`
  margin-bottom: 40px;
  padding: 12px 34px;
  width: 100%;
  @media (min-width: 768px) {
    margin-bottom: 0;
    width: auto;
    flex: 0 0 auto;
  }
  div {
    ${rtl("padding-right", "padding-left")}: 8px;
    display: flex;
    transform: scaleX(${rtl("-1", "1")});
  }
`;

export const RequiredSpan = styled.span`
  font-size: 12px;
  color: #d21c1c;
  font-weight: 400;
  height: 0;
  margin-top: 4px;
`;

export const PhoneField = styled(FlexCol)<{ fullWidth?: boolean }>`
  align-items: flex-start;
  width: 100%;

  @media (min-width: 768px) {
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "50%")};
  }
`;
